export const convertCamelCaseToUserFriendly = (str: string) =>
  `${str.charAt(0).toUpperCase()}${str.slice(1).replace(/([A-Z])/g, ' $1')}`;
